import { schema } from 'normalizr';

const getAccountGOSAgreements = new schema.Entity('accountGOSAgreements');

export default getAccountGOSAgreements;
